import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import router from "./router/index";
import App from "./App.vue";
import "mint-ui/lib/style.css";
import "./assets/style.css";

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
